/* eslint-disable */
import { CurrentPlan } from '../models/current.plan.model';

export const CurrentPlanData: CurrentPlan = {
  client_code: '00351',
  client_group_code: '00296',
  plan_category: 'S',
  company_code: 'D',
  plan_number: 'ORB0000150',
  scheme_code: 'T3F',
  reference_number: '0005123',
  dd_amount: 8.99,
  dd_details: {
    sort_code: '****01',
    account_number: '******90',
    name: 'J Smith',
    nom_pay_day: '03',
    payment_token: 'VU700292801340540',
  },
};
